import { Search, ChevronUp, ChevronDown } from "lucide-react";

const EditView = ({
	families,
	searchQuery,
	onSearchChange,
	onCancel,
	onSave,
	onFamilyChange,
	onToggleSelect,
	onToggleSelectAll,
	allSelected,
	sortColumn,
	sortDirection,
	onSort,
	anySelected,
	onDeleteItems,
	onFamilyPhotoChange,
}) => {
	const getColorStyle = (familyCode, familyName) => {
		if (familyCode === "#" || familyName.toLowerCase() === "clear") {
			return "color-families__color-preview--transparent";
		}
		if (familyCode === "*" || familyName.toLowerCase() === "multicolor") {
			return "color-families__color-preview--multicolor";
		}
		return "";
	};

	const getColorBackground = (familyCode, familyName) => {
		if (familyCode === "#" || familyName.toLowerCase() === "clear") {
			return {};
		}
		if (familyCode === "*" || familyName.toLowerCase() === "multicolor") {
			return {};
		}
		const hexCode = familyCode.startsWith("#") ? familyCode : `#${familyCode}`;
		return { backgroundColor: hexCode };
	};

	const handleColorPickerChange = (id, color) => {

		onFamilyChange(id, "familyCode", color);
	};

	const SortIcon = ({ column }) => {
		if (sortColumn !== column) {
			return (
				<ChevronUp
					className="color-families__sort-icon"
					style={{ opacity: 0.3 }}
				/>
			);
		}
		return sortDirection === "asc" ? (
			<ChevronUp className="color-families__sort-icon" />
		) : (
			<ChevronDown className="color-families__sort-icon" />
		);
	};

	return (
		<>
			<div className="color-families__controls">
				<div className="color-families__search-wrapper">
					<Search className="color-families__search-icon" size={18} />
					<input
						type="text"
						className="color-families__search"
						placeholder=" Search color families"
						value={searchQuery}
						onChange={(e) => onSearchChange(e.target.value)}
					/>
				</div>
				{allSelected || anySelected ? (
					<div style={{ marginLeft: "auto", display: "flex", gap: "16px" }}>
						<button
							className="color-families__delete-btn"
							onClick={onDeleteItems}
						>
							{`Delete ${allSelected ? "all items" : "seleted items"}`}
						</button>
					</div>
				) : (
					<div style={{ marginLeft: "auto", display: "flex", gap: "16px" }}>
						<button className="color-families__cancel-btn" onClick={onCancel}>
							Cancel
						</button>
						<button className="color-families__save-btn" onClick={onSave}>
							Save items
						</button>
					</div>
				)}
			</div>

			<div className="color-families__table-wrapper">
				<table className="color-families__table">
					<thead>
						<tr>
							<th>
								<span
									className="color-families__sort-header"
									onClick={() => onSort("familyName")}
								>
									Family name
									<SortIcon column="familyName" />
								</span>
							</th>
							<th>Family code & Pattern</th>
							<th>Colors in Family</th>
							<th>
								{/* <div className="color-families__select-all">
									Select all
									<input
										type="checkbox"
										className="color-families__checkbox"
										checked={allSelected}
										onChange={onToggleSelectAll}
									/>
								</div> */}
							</th>
						</tr>
					</thead>
					<tbody>
						{families.map((family) => (
							<tr key={family.id}>
								<td>
									<input
										type="text"
										className="color-families__input"
										value={family.familyName}
										onChange={(e) =>
											onFamilyChange(family.id, "familyName", e.target.value)
										}
									/>
								</td>
								<td>
									<div className="color-families__code-input-wrapper">
										{["#", "*"].includes(family.familyCode) && (
											<div
												className={`color-families__color-preview ${getColorStyle(
													family.familyCode,
													family.familyName
												)}`}
												style={getColorBackground(
													family.familyCode,
													family.familyName
												)}
											/>
										)}
										{!["#", "*"].includes(family.familyCode) ? (
											<>
												<div className="color-families__color-picker-btn">
													<input
														type="color"
														value={
															family.familyCode.startsWith("#")
																? family.familyCode
																: `#${family.familyCode}`
														}
														onChange={(e) =>
															handleColorPickerChange(family.id, e.target.value)
														}
													/>
												</div>
												<input
													type="text"
													className="color-families__code-input"
													value={family.familyCode}
													onChange={(e) =>
														onFamilyChange(
															family.id,
															"familyCode",
															e.target.value
														)
													}
												/>
											</>
										) : (
											<span>{family.familyCode}</span>
										)}
									</div>
									{!["#", "*"].includes(family.familyCode) && (
										<div className="color-families__url-input-section" style={{ marginTop: '8px' }}>
											<input
												type="url"
												className="color-families__url-input"
												placeholder="Enter image URL"
												value={family.url || ''}
												onChange={(e) => onFamilyPhotoChange(family.id, e.target.value)}
												style={{
													width: '100%',
													padding: '6px 8px',
													border: '1px solid #cbd5e1',
													borderRadius: '4px',
													fontSize: '12px'
												}}
											/>
											{family.url && (
												<div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
													<div className="color-families__url-preview-inline" style={{
														width: '36px',
														height: '36px',
														borderRadius: '4px',
														overflow: 'hidden',
														border: '1px solid #e2e8f0'
													}}>
														<img
															src={family.url}
															alt="Pattern"
															style={{ width: '100%', height: '100%', objectFit: 'cover' }}
														/>
													</div>
													<span style={{ fontSize: '12px', color: '#64748b' }}>Image</span>
												</div>
											)}
										</div>
									)}
								</td>
								<td>
									<div style={{ position: "relative" }}>
										<textarea
											className="color-families__textarea"
											value={family.colorsIncluded}
											onChange={(e) =>
												onFamilyChange(
													family.id,
													"colorsIncluded",
													e.target.value
												)
											}
										/>
									</div>
								</td>
								<td>
									{/* {!["#", "*"].includes(family.familyCode) && (
										<input
											type="checkbox"
											className="color-families__checkbox"
											checked={family.selected || false}
											onChange={() => onToggleSelect(family.id)}
										/>
									)} */}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</>
	);
};

export default EditView;
